import { FullApiClientConfiguration, MultiRegionApiConfiguration } from '@ftr/api-shared'
import { AuthenticationService } from '@ftr/ui-user'

/**
 * The options that we pass to auth0/angular-jwt. See: https://github.com/auth0/angular2-jwt#configuration-options
 */
export function jwtOptionsFactory(
  authenticationService: AuthenticationService,
  configurationService: FullApiClientConfiguration,
): any {
  const domain = sanitiseUrl(configurationService.server.rawUrl)
  const regionalDomains = extractEndpointMapDomains(configurationService.regionalApi)
  const playbackDomains = extractEndpointMapDomains(configurationService.playbackApi)
  const courtUploaderServerDomains = extractEndpointMapDomains(configurationService.courtUploaderServer)
  const digitalJusticeDomains = extractEndpointMapDomains(configurationService.digitalJusticeApi)
  const auditDomains = extractEndpointMapDomains(configurationService.auditApi)
  const reportingDomains = extractEndpointMapDomains(configurationService.reportingApi)
  const externalOrganizationDomains = extractEndpointMapDomains(configurationService.externalOrganizationApi)

  return {
    tokenGetter: async () => {
      try {
        return await authenticationService.currentJwtToken
      } catch {
        return undefined
      }
    },
    allowedDomains: [domain].concat(
      regionalDomains,
      courtUploaderServerDomains,
      digitalJusticeDomains,
      auditDomains,
      reportingDomains,
      externalOrganizationDomains,
      playbackDomains,
    ),
    headerName: AuthenticationService.authHeader,
    authScheme: '',
  }
}

function extractEndpointMapDomains(configuration: MultiRegionApiConfiguration): string[] {
  return Object.values(configuration.endpointMap).map(endpoint => {
    return sanitiseUrl(endpoint)
  })
}

function sanitiseUrl(url: string): string {
  return url.replace(/^https?:\/\//, '').replace('/', '')
}
